import { render, staticRenderFns } from "./SelecionaElemento.vue?vue&type=template&id=c3f28dd2"
import script from "./SelecionaElemento.vue?vue&type=script&lang=js"
export * from "./SelecionaElemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports